"use client";
import React, { useEffect } from 'react';
import { getPartNumberCookie, setPartNumberCookie } from 'utils/cookieUtils';
import { COOKIE_BROWSING_HISTORY, MAX_DAYS, BY_COMMA, MAX_PRODUCTS, PATH } from "../../constants/constants";
import { getExpiryDateFromNow } from '../../utils/commonUtils';

const GetBrowsingHistoryCookie = ({ partNumber }: { partNumber: string }) => {
    function updateBrowsingHistoryCookie(productNumber: string) {
        const partNumber = productNumber.replace('-PRODUCT', '');
        const cookie = getPartNumberCookie(COOKIE_BROWSING_HISTORY);
        const expiryDate = getExpiryDateFromNow(MAX_DAYS);
        if (cookie) {
            const productsViewed = cookie.split(BY_COMMA);
            const productList = [...new Set([partNumber, ...productsViewed])];

            // ArrayProducts musn't exceed 200 elements
            productList.length >= MAX_PRODUCTS &&
                productList.splice(MAX_PRODUCTS - 1, productList.length - MAX_PRODUCTS);

            const browsingHistoryCookieValue = [...productList].join(BY_COMMA);
            setPartNumberCookie(
                COOKIE_BROWSING_HISTORY,
                browsingHistoryCookieValue,
                PATH,
                expiryDate
            );
        } else {
            setPartNumberCookie(COOKIE_BROWSING_HISTORY, partNumber, PATH, expiryDate);
        }
    }
    // Adds part to browsing history cookie
    useEffect(() => {
        if (partNumber) {
            updateBrowsingHistoryCookie(partNumber);
        }
    }, [partNumber]);
    return null;
}

export default React.memo(GetBrowsingHistoryCookie);
